import React, { useState, useEffect } from "react";
import {
  FaUsers,
  FaFileInvoice,
  FaCog,
  FaClipboardList,
  FaImage,
  FaSignOutAlt,
  FaHome,
  FaReceipt,
} from "react-icons/fa";
import { FiBell } from "react-icons/fi";

import { MdOutlineQuestionAnswer } from "react-icons/md";

import { RxDashboard } from "react-icons/rx";
import { useNavigate, useLocation, Navigate, Link } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const Sidebar = () => {
  const [isLogginOut, setLoggingOut] = useState(false);
  const navigation = [
    { name: "Torna al sito", href: "/", icon: <FaHome /> },
    { name: "Dashboard", href: "/admin/dashboard", icon: <RxDashboard /> },
    { name: "Notifiche", href: "/admin/notifiche", icon: <FiBell /> },
    { name: "Utenti", href: "/admin/users", icon: <FaUsers /> },

    {
      name: "Abbonamenti",
      href: "/admin/gestione-abbonamenti",
      icon: <FaFileInvoice />,
    },
    { name: "Ordini", href: "/admin/gestione-ordini", icon: <FaReceipt /> },
    { name: "Riviste", href: "/admin/riviste", icon: <FaClipboardList /> },

    {
      name: "FAQs",
      href: "/admin/gestione-faqs",
      icon: <MdOutlineQuestionAnswer />,
    },
    {
      name: "Disconnettiti",
      href: "#",
      icon: <FaSignOutAlt />,
      action: () => logout(),
    },
  ];

  const logout = async () => {
    axios.defaults.withCredentials = true;
    try {
      const response = await axios.get(`${API_URL}/logout`, {});
      localStorage.clear();
      setLoggingOut(true);
    } catch (err) {
      console.log(err);
    }
  };

  if (isLogginOut) {
    // Reindirizza alla pagina di login quando `loggingOut` è true
    return <Navigate to="/login" />;
  }

  return (
    <aside className="w-64 bg-gray-800 text-white p-6">
      <h2 className="text-2xl font-semibold mb-6">Admin Panel</h2>
      <ul className="space-y-4">
        {navigation.map((item, index) => (
          <li key={index}>
            {/* Se l'item ha una funzione "action", utilizza un button, altrimenti usa il Link */}
            {item.action ? (
              <button
                onClick={item.action}
                className="flex items-center space-x-2 hover:bg-gray-700 p-2 rounded transition w-full text-left"
              >
                {item.icon && <span>{item.icon}</span>}
                <span>{item.name}</span>
              </button>
            ) : (
              <Link
                to={item.href}
                className="flex items-center space-x-2 hover:bg-gray-700 p-2 rounded transition"
              >
                {item.icon && <span>{item.icon}</span>}
                <span>{item.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
